import * as qs from 'qs';

function hasQueryParams(url) {
  return url.match(/\?/);
}

function extractUrl(url) {
  if (hasQueryParams(url)) {
    return url.replace(/\?.*/, '');
  }

  return url;
}

function extractQuery(url) {
  if (hasQueryParams(url)) {
    return url.replace(/.*\?/, '');
  }
  return '';
}

function urlAndQueryParams(url) {
  return { url: extractUrl(url), params: qs.parse(extractQuery(url)) };
}

function listingWithAdditionalParams(listingJSON, params) {
  const extractedUrl = urlAndQueryParams(listingJSON._links.web.href);
  const newParams = Object.assign(extractedUrl.params, params);
  const listingHref =
    `${extractedUrl.url}?${qs.stringify(newParams)}`;

  const newListingJson = Object.assign(
    {},
    listingJSON,
    { _links: { web: { href: listingHref } } },
  );

  return newListingJson;
}

function listingWithAid(listingJSON, aid) {
  return listingWithAdditionalParams(listingJSON, { _aid: aid });
}

const exported = {
  listingWithAid,
  listingWithAdditionalParams,
};

export default exported;
export { listingWithAid, listingWithAdditionalParams };



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/listing_with_aid.js